import React, { useState } from 'react';
import { X } from 'lucide-react';

const SwitchPlanModal = ({ darkMode, onClose, onConfirm }) => {
  const [startDate, setStartDate] = useState(() => {
    const today = new Date();
    return today.toISOString().split('T')[0];
  });

  const handleConfirm = () => {
    onConfirm(startDate);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className={darkMode ? 'bg-slate-800 rounded-2xl p-6 w-full max-w-md border border-slate-700' : 'bg-white rounded-2xl p-6 w-full max-w-md shadow-xl'}>
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-xl font-semibold">Switch Training Plan?</h3>
          <button onClick={onClose} className={darkMode ? 'text-slate-400 hover:text-white' : 'text-slate-400 hover:text-slate-600'}>
            <X className="w-6 h-6" />
          </button>
        </div>

        <div className="space-y-4">
          <p className={darkMode ? 'text-slate-300' : 'text-slate-600'}>
            All runs before the start date will be preserved. Planned runs from the start date onwards will be replaced with your new plan.
          </p>

          <div>
            <label className={darkMode ? 'block text-sm font-medium mb-1.5 text-slate-300' : 'block text-sm font-medium mb-1.5 text-slate-700'}>
              When should your new plan start?
            </label>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className={darkMode ? 'w-full p-3 rounded-xl border bg-slate-700 border-slate-600 text-white' : 'w-full p-3 rounded-xl border border-slate-300'}
            />
          </div>

          <div className="flex gap-3 mt-6">
            <button
              onClick={onClose}
              className={darkMode ? 'flex-1 py-3 rounded-xl border border-slate-600 hover:bg-slate-700 transition-colors' : 'flex-1 py-3 rounded-xl border border-slate-300 hover:bg-slate-50 transition-colors'}
            >
              Cancel
            </button>
            <button
              onClick={handleConfirm}
              className="flex-1 py-3 rounded-xl bg-sky-500 text-white hover:bg-sky-600 transition-colors font-medium"
            >
              Confirm Switch
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SwitchPlanModal;
